// import { useState, useEffect } from "react";
// import * as FeatherIcon from "react-feather";
// import APP_CONFIG from "../../../config/appConfig";
// import "../BenchmarkDetails/CreateBenchmarkWizard/WizardSidebar.css";
// import { useUser } from "../../../context/UserContext";
// import Alert from "../../HtmlElements/Alert";
// import { Modal } from "react-bootstrap";

// const SCORECARD_SUFFIX = "ScoreCard";

// const getScorecardSubs = (category) =>
//   category.subDimensions.filter((sub) => sub.endsWith(SCORECARD_SUFFIX));

// const isScorecard = (sub) => sub.endsWith(SCORECARD_SUFFIX);

// const getDisplayName = (sub) => {
//   if (isScorecard(sub)) return "Company Scorecard";

//   // optional: custom mapping
//   const displayMap = {
//     "Market by application": "By Application",
//     "Market by technology": "By Technology",
//     "Market by geography": "By Geography",
//     "Future Bets": "Future Bets & Leadership-Led Initiatives",
//     "Marketing Geographic Coverage": "Marketing & Geographic Coverage",
//     "Quantitative Snapshot": "Quant Snapshot",
//     "Org Chart": "Organizational Hierarchy",
//     "Business Segment": "Business Segment Structure",
//     "Strategic Themes": "Strategic Leadership Themes",
//   };

//   return displayMap[sub] || sub;
// };

// const getSelectedScorecardCount = (category, selectedSubs) => {
//   const scorecards = getScorecardSubs(category);

//   return scorecards.filter((s) => selectedSubs.includes(s)).length;
// };

// const UpdateCompProfileDimensions = ({
//   existingSubdimensions = [],
//   onSubmit,
//   onCancel,
// }) => {
//   const { user } = useUser();
//   const defaultCategories =
//     user?.demo === APP_CONFIG?.market_iq_demo
//       ? APP_CONFIG?.marketIqCompetitorProfileCategories
//       : APP_CONFIG?.competitorProfileCategories;
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");

//   // Selected subdimensions (flat array)
//   const [selectedSubs, setSelectedSubs] = useState([]);

//   // Only one category open at a time
//   const [expandedCategory, setExpandedCategory] = useState(null);

//   useEffect(() => {
//     const subs = Array.isArray(existingSubdimensions)
//       ? existingSubdimensions
//       : existingSubdimensions?.data || [];

//     setSelectedSubs(subs);
//   }, [existingSubdimensions]);

//   // Accordion toggle (only one open at a time)
//   const toggleExpand = (catName) => {
//     setExpandedCategory((prev) => (prev === catName ? null : catName));
//   };

//   // const toggleSubdimension = (sub) => {
//   //   setSelectedSubs((prev) =>
//   //     prev.includes(sub) ? prev.filter((item) => item !== sub) : [...prev, sub]
//   //   );
//   // };

//   const toggleSubdimension = (sub, category) => {
//     // If it's scorecard group
//     if (isScorecard(sub)) {
//       const scorecards = getScorecardSubs(category);

//       const allSelected = scorecards.every((s) => selectedSubs.includes(s));

//       if (allSelected) {
//         // remove all scorecards
//         setSelectedSubs((prev) =>
//           prev.filter((item) => !scorecards.includes(item))
//         );
//       } else {
//         // add all scorecards
//         setSelectedSubs((prev) => [
//           ...prev,
//           ...scorecards.filter((s) => !prev.includes(s)),
//         ]);
//       }

//       return;
//     }

//     // normal behavior
//     setSelectedSubs((prev) =>
//       prev.includes(sub) ? prev.filter((item) => item !== sub) : [...prev, sub]
//     );
//   };

//   const toggleCategory = (category) => {
//     const allSelected = category.subDimensions.every((sub) =>
//       selectedSubs.includes(sub)
//     );

//     if (allSelected) {
//       // Remove all subdimensions of that category
//       setSelectedSubs((prev) =>
//         prev.filter((sub) => !category.subDimensions.includes(sub))
//       );
//     } else {
//       // Add all missing subdimensions
//       const toAdd = category.subDimensions.filter(
//         (sub) => !selectedSubs.includes(sub)
//       );
//       setSelectedSubs((prev) => [...prev, ...toAdd]);
//     }
//   };

//   const isAllChecked = (category) =>
//     category.subDimensions.every((sub) => selectedSubs.includes(sub));

//   const handleSubmit = () => {
//     if (!selectedSubs.length) {
//       setErrorMessage("Please select at least one sub-dimension.");
//       setTimeout(() => setErrorMessage(""), 6000);
//       return;
//     }

//     setShowConfirmModal(true);
//   };

//   const confirmUpdate = () => {
//     setShowConfirmModal(false);
//     onSubmit(selectedSubs);
//   };

//   return (
//     <div className="p-3 w-100">
//       {successMessage && <Alert type="success" message={successMessage} />}
//       {errorMessage && <Alert type="danger" message={errorMessage} />}
//       <div className="wizard_five">
//         <h5 className="mb-3">Update Competitor Profile Dimensions</h5>

//         {defaultCategories.map((cat, index) => {
//           const isOpen = expandedCategory === cat.name;

//           return (
//             <div className="mb-3 custom_form_accordian" key={index}>
//               <div
//                 className={`custom_form_accordian_default ${
//                   isOpen
//                     ? "custom_form_accordian_open"
//                     : "custom_form_accordian_close"
//                 }`}
//               >
//                 {/* Header */}
//                 <div
//                   className="custom_accord_head_block cursor_p"
//                   onClick={() => toggleExpand(cat.name)}
//                 >
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-outline-secondary btn_accordian_arrow"
//                   >
//                     {isOpen ? (
//                       <FeatherIcon.ChevronDown className="next_feather" />
//                     ) : (
//                       <FeatherIcon.ChevronUp className="next_feather" />
//                     )}
//                   </button>

//                   <div className="input_lable_align">
//                     <input
//                       type="checkbox"
//                       className="form-check-input me-2"
//                       checked={isAllChecked(cat)}
//                       onChange={(e) => {
//                         e.stopPropagation(); // prevent accordion toggle
//                         toggleCategory(cat);
//                       }}
//                     />

//                     <label
//                       className={`form-check-label ${
//                         isOpen ? "text-primary" : ""
//                       }`}
//                       style={{ cursor: "pointer" }}
//                     >
//                       {cat.name}
//                       <small className="ms-2">
//                         (
//                         {
//                           // cat.subDimensions.filter((sub) =>
//                           //   selectedSubs.includes(sub)
//                           // ).length
//                         }
//                         {/* /{cat.subDimensions.length}) */}
//                         {getSelectedCount(cat, selectedSubs)}/
//                         {getTotalCount(cat)})
//                       </small>
//                     </label>
//                   </div>
//                 </div>

//                 {/* Subdimensions */}
//                 {isOpen && (
//                   <div className="ms-4 mt-2 sub_form_check_block">
//                     <p className="select_input">Select sub categories</p>

//                     {cat.subDimensions
//                       .filter((sub, index, arr) => {
//                         // show only first scorecard as "Company Scorecard"
//                         if (isScorecard(sub)) {
//                           return index === arr.findIndex((s) => isScorecard(s));
//                         }
//                         return true;
//                       })
//                       .map((sub, subIndex) => (
//                         <div
//                           className="form-check sub_form_check"
//                           key={subIndex}
//                         >
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             // checked={selectedSubs.includes(sub)}
//                             checked={
//                               isScorecard(sub)
//                                 ? getScorecardSubs(cat).every((s) =>
//                                     selectedSubs.includes(s)
//                                   )
//                                 : selectedSubs.includes(sub)
//                             }
//                             onChange={() => toggleSubdimension(sub, cat)}
//                             id={`${cat.name}-${subIndex}`}
//                           />
//                           <label
//                             className="form-check-label"
//                             htmlFor={`${cat.name}-${subIndex}`}
//                           >
//                             {/* {sub} */}
//                             {getDisplayName(sub)}
//                           </label>
//                         </div>
//                       ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           );
//         })}

//         {/* Footer Buttons */}
//         <div className="d-flex justify-content-end mt-4">
//           <button
//             className="btn btn-secondary previous_btn_wz me-2"
//             onClick={onCancel}
//           >
//             Cancel
//           </button>

//           <button
//             className="btn btn-primary next_btn_wz"
//             onClick={handleSubmit}
//           >
//             Submit <FeatherIcon.ChevronRight className="next_feather" />
//           </button>
//         </div>
//       </div>

//       <Modal
//         show={showConfirmModal}
//         onHide={() => setShowConfirmModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Update</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <p>
//             You have selected{" "}
//             <strong>
//               {getFinalSelectedCount(defaultCategories, selectedSubs)}
//             </strong>{" "}
//             sub-dimension(s).
//           </p>
//           <p>Are you sure you want to update this competitor profile?</p>
//         </Modal.Body>

//         <Modal.Footer>
//           <button
//             className="profile-card-button"
//             onClick={() => setShowConfirmModal(false)}
//           >
//             Cancel
//           </button>

//           <button
//             className="profile-card-button profile-card-button-primary"
//             onClick={confirmUpdate}
//           >
//             Confirm
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default UpdateCompProfileDimensions;

import { useState, useEffect } from "react";
import * as FeatherIcon from "react-feather";
import APP_CONFIG from "../../../config/appConfig";
import "../BenchmarkDetails/CreateBenchmarkWizard/WizardSidebar.css";
import { useUser } from "../../../context/UserContext";
import Alert from "../../HtmlElements/Alert";
import { Modal } from "react-bootstrap";

const SCORECARD_SUFFIX = "ScoreCard";

const getScorecardSubs = (category) =>
  category.subDimensions.filter((sub) => sub.endsWith(SCORECARD_SUFFIX));

const isScorecard = (sub) => sub.endsWith(SCORECARD_SUFFIX);

const getDisplayName = (sub) => {
  if (isScorecard(sub)) return "Company Scorecard";

  const displayMap = {
    "Market by application": "By Application",
    "Market by technology": "By Technology",
    "Market by geography": "By Geography",
    "Future Bets": "Future Bets & Leadership-Led Initiatives",
    "Marketing Geographic Coverage": "Marketing & Geographic Coverage",
    "Quantitative Snapshot": "Quant Snapshot",
    "Org Chart": "Organizational Hierarchy",
    "Business Segment": "Business Segment Structure",
    "Strategic Themes": "Strategic Leadership Themes",
  };

  return displayMap[sub] || sub;
};

const UpdateCompProfileDimensions = ({
  existingSubdimensions = [],
  onSubmit,
  onCancel,
}) => {
  const { user } = useUser();

  const defaultCategories =
    user?.demo === APP_CONFIG?.market_iq_demo
      ? APP_CONFIG?.marketIqCompetitorProfileCategories
      : APP_CONFIG?.competitorProfileCategories;
  const [initialSubs, setInitialSubs] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [selectedSubs, setSelectedSubs] = useState([]);
  const [expandedCategory, setExpandedCategory] = useState(null);

  // useEffect(() => {
  //   const subs = Array.isArray(existingSubdimensions)
  //     ? existingSubdimensions
  //     : existingSubdimensions?.data || [];

  //   setSelectedSubs(subs);
  // }, [existingSubdimensions]);

  useEffect(() => {
    const subs = Array.isArray(existingSubdimensions)
      ? existingSubdimensions
      : existingSubdimensions?.data || [];

    setSelectedSubs(subs);
    setInitialSubs(subs);
  }, [existingSubdimensions]);

  // HELPERS

  const getSelectedCount = (cat) => {
    const scorecards = getScorecardSubs(cat);

    const normalCount = cat.subDimensions.filter(
      (sub) => !isScorecard(sub) && selectedSubs.includes(sub)
    ).length;

    const scorecardSelected = scorecards.some((s) => selectedSubs.includes(s))
      ? 1
      : 0;

    return normalCount + scorecardSelected;
  };

  const getTotalCount = (cat) => {
    const scorecards = getScorecardSubs(cat).length;

    return cat.subDimensions.length - scorecards + (scorecards ? 1 : 0);
  };

  const getFinalSelectedCount = () => {
    return defaultCategories.reduce(
      (acc, cat) => acc + getSelectedCount(cat),
      0
    );
  };

  // const getRemovedSubdimensions = () => {
  //   return initialSubs.filter((sub) => !selectedSubs.includes(sub));
  // };

  const getRemovedSubdimensions = () => {
    const removed = initialSubs.filter((sub) => !selectedSubs.includes(sub));

    // handle scorecard edge case
    const allScorecards = defaultCategories.flatMap((cat) =>
      getScorecardSubs(cat)
    );

    const initialScorecards = initialSubs.filter((s) =>
      allScorecards.includes(s)
    );

    const selectedScorecards = selectedSubs.filter((s) =>
      allScorecards.includes(s)
    );

    if (initialScorecards.length && selectedScorecards.length === 0) {
      return [...removed, ...initialScorecards];
    }

    return removed;
  };

  // Accordion toggle
  const toggleExpand = (catName) => {
    setExpandedCategory((prev) => (prev === catName ? null : catName));
  };

  const toggleSubdimension = (sub, category) => {
    if (isScorecard(sub)) {
      const scorecards = getScorecardSubs(category);

      const allSelected = scorecards.every((s) => selectedSubs.includes(s));

      if (allSelected) {
        setSelectedSubs((prev) =>
          prev.filter((item) => !scorecards.includes(item))
        );
      } else {
        setSelectedSubs((prev) => [
          ...prev,
          ...scorecards.filter((s) => !prev.includes(s)),
        ]);
      }
      return;
    }

    setSelectedSubs((prev) =>
      prev.includes(sub) ? prev.filter((item) => item !== sub) : [...prev, sub]
    );
  };

  const toggleCategory = (category) => {
    const allSelected = category.subDimensions.every((sub) =>
      selectedSubs.includes(sub)
    );

    if (allSelected) {
      setSelectedSubs((prev) =>
        prev.filter((sub) => !category.subDimensions.includes(sub))
      );
    } else {
      const toAdd = category.subDimensions.filter(
        (sub) => !selectedSubs.includes(sub)
      );

      setSelectedSubs((prev) => [...prev, ...toAdd]);
    }
  };

  const isAllChecked = (category) =>
    category.subDimensions.every((sub) => selectedSubs.includes(sub));

  const handleSubmit = () => {
    if (!selectedSubs.length) {
      setErrorMessage("Please select at least one sub-dimension.");
      setTimeout(() => setErrorMessage(""), 6000);
      return;
    }

    setShowConfirmModal(true);
  };

  const confirmUpdate = () => {
    setShowConfirmModal(false);
    // onSubmit(selectedSubs);
    const removedSubDimensions = getRemovedSubdimensions();
    onSubmit({
      selected_subdimensions: selectedSubs,
      removed_subdimensions: removedSubDimensions,
    });
  };

  return (
    <div className="p-3 w-100">
      {successMessage && <Alert type="success" message={successMessage} />}
      {errorMessage && <Alert type="danger" message={errorMessage} />}

      <div className="wizard_five">
        <h5 className="mb-3">Update Competitor Profile Dimensions</h5>

        {defaultCategories.map((cat, index) => {
          const isOpen = expandedCategory === cat.name;

          return (
            <div className="mb-3 custom_form_accordian" key={index}>
              <div
                className={`custom_form_accordian_default ${
                  isOpen
                    ? "custom_form_accordian_open"
                    : "custom_form_accordian_close"
                }`}
              >
                <div
                  className="custom_accord_head_block cursor_p"
                  onClick={() => toggleExpand(cat.name)}
                >
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary btn_accordian_arrow"
                  >
                    {isOpen ? (
                      <FeatherIcon.ChevronDown className="next_feather" />
                    ) : (
                      <FeatherIcon.ChevronUp className="next_feather" />
                    )}
                  </button>

                  <div className="input_lable_align">
                    <input
                      type="checkbox"
                      className="form-check-input me-2"
                      checked={isAllChecked(cat)}
                      onChange={(e) => {
                        e.stopPropagation();
                        toggleCategory(cat);
                      }}
                    />

                    <label
                      className={`form-check-label ${
                        isOpen ? "text-primary" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                    >
                      {cat.name}
                      <small className="ms-2">
                        ({getSelectedCount(cat)}/{getTotalCount(cat)})
                      </small>
                    </label>
                  </div>
                </div>

                {isOpen && (
                  <div className="ms-4 mt-2 sub_form_check_block">
                    <p className="select_input">Select sub categories</p>

                    {cat.subDimensions
                      .filter((sub, index, arr) => {
                        if (isScorecard(sub)) {
                          return index === arr.findIndex((s) => isScorecard(s));
                        }
                        return true;
                      })
                      .map((sub, subIndex) => (
                        <div
                          className="form-check sub_form_check"
                          key={subIndex}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={
                              isScorecard(sub)
                                ? getScorecardSubs(cat).every((s) =>
                                    selectedSubs.includes(s)
                                  )
                                : selectedSubs.includes(sub)
                            }
                            onChange={() => toggleSubdimension(sub, cat)}
                            id={`${cat.name}-${subIndex}`}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${cat.name}-${subIndex}`}
                          >
                            {getDisplayName(sub)}
                          </label>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          );
        })}

        <div className="d-flex justify-content-end mt-4">
          <button
            className="btn btn-secondary previous_btn_wz me-2"
            onClick={onCancel}
          >
            Cancel
          </button>

          <button
            className="btn btn-primary next_btn_wz"
            onClick={handleSubmit}
          >
            Submit <FeatherIcon.ChevronRight className="next_feather" />
          </button>
        </div>
      </div>

      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            You have selected <strong>{getFinalSelectedCount()}</strong>{" "}
            sub-dimension(s).
          </p>
          <p>Are you sure you want to update this competitor profile?</p>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="profile-card-button"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </button>

          <button
            className="profile-card-button profile-card-button-primary"
            onClick={confirmUpdate}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UpdateCompProfileDimensions;
